/* eslint-disable no-nested-ternary */
import React, {
  useReducer, useContext, useEffect, useState,
} from 'react';
import { FaSpinner } from 'react-icons/fa';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { GatsbyImage } from "gatsby-plugin-image";
import CartHandler from '../Services/CartService';
import { CartContext } from '../Context/CartContext';
import closeIcon from '../../images/cart-remove.png';
import { useGlobalDispatch, useGlobalState } from '../Context/globalContext';
import StaImage from '../Helpers/StaImage'

const CartItem = (props) => {
  const value = useContext(CartContext);
  const globalDispatch = useGlobalDispatch();
  const {cartCount} = useGlobalState();
 
  const { stock, outOfStockError, orderItem } = value.state;
  const {
    order_id, order_item_id, color, size, storeName, cartItemImage, quantity, total_price, purchased_entity, index,
  } = props;
  const {
    title, variation_id, product_id
  } = purchased_entity || '';
  const [fetching, setFetching] = useState(false);

  const queryParams = {
    product_id,
  };
  // Dynamic query to fetch item attributes as they are not available by default.
  // Fetching data with Product Id since Product type is not available.
  const { data, loading } = useQuery(GET_CART_PRODUCT_ATTRIBUTE_VALUES, { variables: queryParams });



  if (!data && !loading) {
    value.dispatch({ type: 'cartData', data: [] });
  } else if (!loading && data.products.nodes.length < 1) {
    value.dispatch({ type: 'cartData', data: [] });
  }

  useEffect(() => {
    if (!loading && data?.products?.nodes?.length > 0) {
      const { variations, stores } = data?.products?.nodes[0]?.relationships;
      const variation = variations.find((item) => item.drupal_internal__variation_id === variation_id);
      const { relationships } = variation || '';
      const {
        attribute_color, attribute_size, attribute_shoe_size, attribute_jewellery_size,
      } = relationships || '';
      let sizeAttr;

      if (attribute_color) {
        orderItem[props.index].color = attribute_color.name;
      }

      sizeAttr = (attribute_size && attribute_size.name)
            || (attribute_jewellery_size && attribute_jewellery_size.name)
            || (attribute_shoe_size && attribute_shoe_size.name);
      orderItem[props.index].size = sizeAttr;

      if (stores[0]) {
        orderItem[props.index].storeName = stores[0].name;
        props.getStoreLocationCallback(stores[0].field_geolocation);
      }
      if (relationships?.field_image[0]?.uri) {
        orderItem[props.index].cartItemImage = relationships?.field_image[0]?.uri?.url;
      }
      value.dispatch({ type: 'orderItem', data: orderItem });
    }
  }, [data]);

  // Add the item Quantity and update associated attributes.
  const addItem = async (quantity, order_item_id, order_id) => {
    const newQuantity = Math.floor(quantity) + 1;
    let cartNumber = cartCount + 1;
    setFetching(true);
    const response = await CartHandler.updateCartItem(newQuantity, order_item_id, order_id);
    globalDispatch({type: 'cartCount', payload: {cartCount: cartNumber}});
    value.dispatch({ type: 'totalPrice', data: response.total_price.number });
    response && setFetching(false);
    orderItem[index] = updateOrderItem(response.order_items[index]);
    value.dispatch({ type: 'orderItem', data: orderItem });
  };

  // Subtract the item Quantity and update associated attributes.
  const minusItem = async (quantity, order_item_id, order_id) => {
    if (quantity <= 1) return;
    const newQuantity = Math.floor(quantity) - 1;
    setFetching(true);
    const response = await CartHandler.updateCartItem(newQuantity, order_item_id, order_id);
    value.dispatch({ type: 'totalPrice', data: response.total_price.number });
     let cartNumber = cartCount - 1;
    globalDispatch({type: 'cartCount', payload: {cartCount: cartNumber}});
    response && setFetching(false);

    orderItem[index] = updateOrderItem(response.order_items[index]);
    value.dispatch({ type: 'orderItem', data: orderItem });
  };

  // Remove item.
  const removeItem = async (order_id, order_item_id, quantity) => {
    let response = await CartHandler.removeCartItem(order_id, order_item_id);
    response = (response) || [];
    value.dispatch({ type: 'cartData', data: response });
    orderItem.splice(index, 1);
    value.dispatch({ type: 'orderItem', data: orderItem });
    let cartNumber = cartCount - quantity;
    globalDispatch({type: 'cartCount', payload: {cartCount: cartNumber}});
  };

  const updateOrderItem = (item) => ({
    ...item,
    storeName,
    color,
    size,
    cartItemImage,
  });

  return (
    <div className="cart-product">
      <div className="cart-product-image">
        { cartItemImage && <StaImage url={cartItemImage} width="445px" paddingBottom="114%"/>}
      </div>
      <div className="cart-product-details">
        <div className="cart-boutique-title">
          {storeName && storeName}
        </div>
        <div className="cart-product-name">
          {title && title}
        </div>

        <div className="cart-product-specs">
          {
            color
              && (
                <p>
                  <span className="spec-title">Color: </span>
                  <span className="spec-value">{color}</span>
                </p>
              )
          }
        </div>

        <div className="cart-product-specs">
          {
            size
              ? (
                <p>
                  <span className="spec-title">Size: </span>
                  <span className="spec-value" />
                  {size}
                </p>
              ) : ''
          }
        </div>

        <div className="cart-product-specs">
          <p>
            <span className="spec-title">Total:</span>
            <span className="spec-value">{total_price.formatted}</span>
          </p>
        </div>
        <div className="cart-quantity">
          <button type="button" onClick={() => minusItem(quantity, order_item_id, order_id)}>
            {(fetching) ? <FaSpinner /> : '-'}
          </button>
          <span className="cart-quantity-value">{quantity}</span>
          <button type="button" onClick={() => addItem(quantity, order_item_id, order_id)}>
            {(fetching) ? <FaSpinner /> : '+'}
          </button>
        </div>
        <div className="spec-value outofStock-msg">
          {stock[variation_id] <= 0 && outOfStockError}
          {stock[variation_id] < quantity && (
          <div>
Only
            {stock[variation_id]}
            {' '}
products available in stock
          </div>
          )}
        </div>
        <div className="cart-remove-item">
          <button type="button" onClick={() => removeItem(order_id, order_item_id, quantity)}>
            <img src={closeIcon} alt="Remove item" />
          </button>
        </div>

      </div>
    </div>
  );
};

const GET_CART_PRODUCT_ATTRIBUTE_VALUES = gql`
query ($product_id: Int){
products: allCommerceProduct(filter: {status: {eq: true}, drupal_internal__product_id: {eq: $product_id}, relationships: {stores: {elemMatch: {field_published: {eq: true}}}}}) {
  nodes {
    relationships {
      stores {
        name
        field_geolocation {
          lat
          lng
        }
      }
      variations {
        ... on commerce_product_variation__clothing {
          drupal_internal__variation_id
          relationships {
            attribute_color {
              name
            }
            attribute_size {
              name
            }
            field_image {
              filename
              uri {
                url
              }
            }
          }
        }
        ... on commerce_product_variation__shoes {
          drupal_internal__variation_id
          relationships {
            attribute_color {
              name
            }
            attribute_shoe_size {
              name
            }
            field_image {
              filename
              uri {
                url
              }
            }
          }
        }
        ... on commerce_product_variation__accessories {
          drupal_internal__variation_id
          relationships {
            attribute_color {
              name
            }
            field_image {
              uri {
                url
              }
            }
          }
        }
        ... on commerce_product_variation__jewellery {
          drupal_internal__variation_id
          relationships {
            attribute_color {
              name
            }
            attribute_jewellery_size {
              name
            }
            field_image {
              filename
              uri {
                url
              }
            }
          }
        }
        ... on commerce_product_variation__customer_membership {
            drupal_internal__variation_id
            relationships {
              field_image {
                filename
                uri {
                  url
                }
              }
            }
          }
      }
    }
  }
}
}`;

export default CartItem;
